import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './registerForm.module.css';
const TermsAndConditions = () => {
    return (_jsxs("div", { className: styles.termsAndConditions, children: ["I agree to the", ' ', _jsx("a", { href: "https://www.oneroomstreaming.com/terms-and-conditions", target: "_blank", rel: "noreferrer", children: "T & C" }), ' ', "and", ' ', _jsx("a", { href: "https://www.oneroomstreaming.com/privacy-policy", target: "_blank", rel: "noreferrer", children: "Privacy Policy" })] }));
};
export default TermsAndConditions;
